import { ProjectAddressGetRecordsList, ProjectsListProjectGetRecordsList } from '@nx-customer-apps/api-planning-projects';

export const basicProjectsToProjectList = (projects: ProjectsListProjectGetRecordsList[]) =>
    projects.map((project: ProjectsListProjectGetRecordsList) => {
        let address: Partial<ProjectAddressGetRecordsList> = {};

        if (project.address.streetName) {
            address.streetName = project.address.streetName;
        }

        address = {
            ...address,
            houseNumber: project.address.houseNumber,
            postalCode: project.address.postalCode,
            city: project.address.city,
            countryCode: project.address.countryCode
        };

        return {
            ...project,
            address
        } as ProjectsListProjectGetRecordsList;
    });
